import { createDraftContext } from './Draft'

export const EmailDraft = createDraftContext()
